import React from "react";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import { getWalletName } from "branding";
import { Alert, Checkbox, Tooltip } from "bitshares-ui-style-guide";
/* Dummy input to trick Chrome into disabling auto-complete */

export const DisableChromeAutocomplete = () => /*#__PURE__*/React.createElement("input", {
  type: "text",
  className: "no-padding no-margin",
  style: {
    visibility: "hidden",
    height: 0
  }
});

const stopPropagation = e => e.stopPropagation();

export const KeyFileLabel = ({
  showUseOtherWalletLink,
  onUseOtherWallet
}) => /*#__PURE__*/React.createElement("div", {
  className: "label-container"
}, /*#__PURE__*/React.createElement("label", {
  className: "left-label login-label"
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.key_file_bin"
}), " "), " ", showUseOtherWalletLink && /*#__PURE__*/React.createElement("a", {
  onClick: onUseOtherWallet
}, "(", /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.use_different"
}), ")"));
export class StyledUpload extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("label", {
      className: "upload-button themed-input"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.restore_key_file"
    }), /*#__PURE__*/React.createElement(UploadButtonLogo, null), /*#__PURE__*/React.createElement("input", {
      type: "file",
      onClick: stopPropagation,
      onChange: this.props.onFileChosen,
      accept: ".bin"
    }));
  }

}
export const CustomError = ({
  message
}) => /*#__PURE__*/React.createElement("div", {
  className: "has-error"
}, message || "");
export const BackupFileSelector = ({
  onFileChosen,
  onRestoreOther
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledUpload, {
  onFileChosen: onFileChosen
}), /*#__PURE__*/React.createElement("div", {
  className: "login-hint"
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.different_file_type"
}), " ", /*#__PURE__*/React.createElement("a", {
  onClick: onRestoreOther
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.restore_it_here"
}))));
export const RestoreBackupOnly = ({
  onFileChosen,
  onRestoreOther
}) => /*#__PURE__*/React.createElement(BackupFileSelector, {
  onFileChosen: onFileChosen,
  onRestoreOther: onRestoreOther
});
export const BackupWarning = ({
  onChange,
  checked
}) => /*#__PURE__*/React.createElement("div", {
  className: "backup-warning"
}, /*#__PURE__*/React.createElement(Alert, {
  type: "warning",
  message: counterpart.translate("alert.warning"),
  description: counterpart.translate("wallet.backup_warning")
}), /*#__PURE__*/React.createElement("div", {
  className: "checkbox"
}, /*#__PURE__*/React.createElement(Checkbox, {
  key: `checkbox_${checked}` // This is needed to prevent slow checkbox reaction
  ,
  onChange: onChange,
  checked: checked
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.dont_ask_for_backup"
}))));
export const LoginButtons = ({
  onLogin,
  backupLogin
}) => /*#__PURE__*/React.createElement(Tooltip, {
  placement: "bottom",
  title: counterpart.translate("tooltip.login", {
    wallet_name: getWalletName()
  })
}, /*#__PURE__*/React.createElement("button", {
  className: "button",
  onClick: onLogin
}, /*#__PURE__*/React.createElement(Translate, {
  content: backupLogin ? "wallet.backup_login" : "header.unlock_short"
})));
export class CustomPasswordInput extends React.Component {
  render = () => /*#__PURE__*/React.createElement("div", {
    className: "content-block account-selector input-area"
  }, /*#__PURE__*/React.createElement("label", {
    className: "left-label login-label"
  }, /*#__PURE__*/React.createElement(Translate, {
    content: "settings.password"
  })), /*#__PURE__*/React.createElement("input", {
    ref: "password_input",
    name: "password",
    id: "password",
    type: "password",
    autoComplete: "current-password"
  }));
}

const UploadButtonLogo = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 6.349999 7.5313201",
  version: "1.1",
  className: "upload-button-logo"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-86.783338,-137.44666)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 89.958337,144.97798 h -3.174999 v -1.18208 -1.18208 l 0.387288,-1.11098 0.387288,-1.11097 h 0.847434 0.847434 v 0.31163 0.31163 l -0.65212,0.17054 -0.652119,0.17053 -0.196798,0.75256 -0.196798,0.75255 h 2.40339 2.403391 l -0.196798,-0.75255 -0.196798,-0.75256 -0.652119,-0.17053 -0.65212,-0.17054 v -0.31163 -0.31163 h 0.847434 0.847434 l 0.387288,1.11097 0.387288,1.11098 v 1.18208 1.18208 z m 0,-3.175 H 89.60556 v -1.2017 -1.20169 l -0.705556,0.1845 -0.705555,0.18451 v -0.33243 -0.33243 l 0.881944,-0.82854 0.881944,-0.82854 0.881945,0.82854 0.881944,0.82854 v 0.33243 0.33243 l -0.705555,-0.18451 -0.705556,-0.1845 v 1.20169 1.2017 z"
})));

export const WalletDisplay = ({
  name,
  onUseOtherWallet
}) => /*#__PURE__*/React.createElement("div", {
  className: "content-box"
}, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.using"
})), " ", name, " ", /*#__PURE__*/React.createElement("a", {
  onClick: onUseOtherWallet
}, "(", /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.use_different"
}), ")"));
export const CreateLocalWalletLink = ({
  onCreate
}) => /*#__PURE__*/React.createElement("div", {
  className: "login-hint"
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.no_wallet",
  component: "span"
}), " ", /*#__PURE__*/React.createElement("span", {
  className: "button",
  onClick: onCreate
}, /*#__PURE__*/React.createElement(Translate, {
  content: "wallet.create_wallet"
})));
export const WalletSelector = ({
  restoringBackup,
  walletNames,
  onWalletChange
}) => /*#__PURE__*/React.createElement("select", {
  value: restoringBackup ? "upload." : "",
  onChange: onWalletChange,
  className: "login-select"
}, /*#__PURE__*/React.createElement("option", {
  value: "",
  hidden: true
}, counterpart.translate("wallet.select_wallet")), walletNames.map(walletName => /*#__PURE__*/React.createElement("option", {
  className: "login-option",
  key: walletName,
  value: `wallet.${walletName}`
}, walletName)), /*#__PURE__*/React.createElement("option", {
  value: "upload."
}, counterpart.translate("settings.backup_backup_short")));